module.exports = __webpack_public_path__ + "img/Technology-text.6c67de55.jpg";